import {
  DefecationEntity,
} from './defecationEntity';
import { DefecationCategory } from './valueObjects/defecationCategory';
import { MeasureDateTime } from './valueObjects/measureDateTime';
import { MeasurerId } from './valueObjects/measurerId';
import { MeasurerType } from './valueObjects/measurerType';
import { ParentId } from './valueObjects/parentId';

import type {
  DefecationPropsPub,
  DefecationPropsPvt,
} from './defecationEntity';
import type { EntityDataPubType } from '@/domain/entityBase';
import type { EntityDataPubNotNullType, EntityPubNotNullType } from '@/domain/entityPub';
import type { DefecationJsonPub, DefecationJsonPvt } from '@/types/domain/defecation/entities/defecationEntity';

import { FactoryPub } from '@/domain/factoryPub';

export class DefecationFactory extends FactoryPub<
  DefecationEntity,
  DefecationPropsPvt,
  DefecationJsonPvt,
  DefecationPropsPub,
  DefecationJsonPub
> {
  comparePub = (
    a: EntityDataPubType<DefecationJsonPvt, DefecationJsonPub>,
    b: EntityDataPubType<DefecationJsonPvt, DefecationJsonPub>,
  ) => {
    const da = new Date(a.data.measureDateTime);
    const db = new Date(b.data.measureDateTime);
    return da < db ? 1 : -1;
  };

  create(
    props: DefecationPropsPvt,
    propsPub: EntityPubNotNullType<DefecationPropsPub>,
  ): DefecationEntity {
    return new DefecationEntity(props, propsPub);
  }

  createFromEntityDataPub(
    props: EntityDataPubNotNullType<DefecationJsonPvt, DefecationJsonPub>,
  ): DefecationEntity {
    return this.create({
      measureDateTime: MeasureDateTime.create(new Date(props.data.measureDateTime)),
      measurerId: MeasurerId.create(props.data.measurerId),
      measurerType: MeasurerType.create(props.data.measurerType),
      parentId: ParentId.create(props.data.parentId),
      childId: ParentId.create(props.data.childId),
      defecationCategory: DefecationCategory.create(props.data.defecationCategory),
    }, {
      sendId: props.pub.sendId,
      replyId: props.pub.replyId,
      data: {},
    });
  }
}
